import { logger } from '../../../../utils/common/logger'
import { Store } from '../../../../utils/storage/keys'
import { IdentityEvent } from '../../../common/events/identity'
import { LoginService } from '../loginradius/services/login-service'
import { IdentityFormAPI } from './form-api'
import { IdentityFormUtils } from './form-utils'

export class PasswordlessEmailForm {
    private static DOM = {
        form: 'sendPasswordlessEmailForm'
    }
    private passwordlessSignInForm: HTMLFormElement
    private isSubmitted = false

    /**
     * Listens for the form validated event in the send passwordless email form
     */
    public init() {
        logger('debug', 'Initializing send passwordless email form')
        this.passwordlessSignInForm = document.querySelector(`[data-id-form=${PasswordlessEmailForm.DOM.form}]`)

        if (this.passwordlessSignInForm) {
            document.addEventListener(IdentityEvent.FORM_VALIDATED, async (event: CustomEvent) => {
                const formType = event.detail.form
                if (formType === PasswordlessEmailForm.DOM.form && !this.isSubmitted) {
                    // the form can be only submitted once so let's prevent further submissions
                    this.isSubmitted = true
                    try {
                        await this.submitForm()
                    } catch (e) {
                        // re-enable form submission if the form submission has failed
                        this.isSubmitted = false
                    }
                }
            })
        }
        logger('debug', 'Send passwordless email form initialized')
    }

    /**
     * Calls send passwordless email API
     */
    public async submitForm() {
        const formData = IdentityFormUtils.getFields()
        const email = formData.emailAddress
        let redirect = location.origin

        // get redirect url
        if (sessionStorage && sessionStorage.getItem(Store.REDIRECT_URL)) {
            const pianoParams = sessionStorage.getItem(Store.PIANO_PARAMS)
            redirect = sessionStorage.getItem(Store.REDIRECT_URL)

            if (redirect.includes('/home-delivery/')) {
                // add campaign, campaign name and offer group to url
                const campaign = sessionStorage.getItem(Store.CAMPAIGN)
                const campaignName = sessionStorage.getItem(Store.CAMPAIGN_NAME)
                const offerGroup = sessionStorage.getItem(Store.OFFER_GROUP)
                // tslint:disable-next-line: max-line-length
                redirect = `${redirect}&${Store.CAMPAIGN}=${campaign}&${Store.CAMPAIGN_NAME}=${campaignName}&${Store.OFFER_GROUP}=${offerGroup}`
            }

            if (pianoParams) {
                // add piano params to url
                redirect = `${redirect}&${Store.PIANO_PARAMS}=${sessionStorage.getItem(Store.PIANO_PARAMS)}`
            }
        }

        const verification = `${location.origin}/verify-passwordless/?redirect=${redirect}`

        try {
            // call send passwordless link email API
            await IdentityFormAPI.sendPasswordlessEmail({email, verification_url: verification})

            // store email in session storage
            sessionStorage.setItem(Store.PASSWORDLESS_EMAIL_ADDRESS, email)

            // send form submission event
            LoginService.sendFormSubmissionEvent('send-passwordless-email')

            location.replace('/passwordless-email-sent/')
        } catch (err) {
            logger('error', 'Unable to send email containing passwordless login link', err)
            throw err
        }
    }
}
